/**
 * Performance 搜尋區：供應商 → 製程別 → 料號 連動
 */
import {
  VENDOR_OPTIONS,
  getProcessTypeOptions,
  getDeviceIsnOptions
} from './mockData'

export default {
  data () {
    return {
      summaryVendor: null,
      summaryAsusDeviceIsn: null,
      summaryProcessType: 'HP',
      summaryVendorMenu: VENDOR_OPTIONS
    }
  },
  computed: {
    summaryProcessTypeMenu () {
      return getProcessTypeOptions(this.summaryVendor)
    },
    summaryAsusDeviceIsnMenu () {
      return getDeviceIsnOptions(this.summaryVendor, this.summaryProcessType)
    }
  },
  watch: {
    summaryVendor () {
      this.syncProcessTypeByVendor()
      this.syncDeviceIsnByCascade()
    },
    summaryProcessType () {
      this.syncDeviceIsnByCascade()
    }
  },
  methods: {
    syncProcessTypeByVendor () {
      const opts = this.summaryProcessTypeMenu
      if (!opts.length) {
        this.summaryProcessType = null
        return
      }
      if (!opts.some(o => o.value === this.summaryProcessType)) {
        this.summaryProcessType = opts[0].value
      }
    },
    syncDeviceIsnByCascade () {
      const opts = this.summaryAsusDeviceIsnMenu
      if (this.summaryAsusDeviceIsn && !opts.some(o => o.value === this.summaryAsusDeviceIsn)) {
        this.summaryAsusDeviceIsn = null
      }
    }
  }
}
